import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=cc394b90&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=cc394b90&prod&lang=scss&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=cc394b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc394b90",
  null
  
)

export default component.exports